module.exports = __webpack_public_path__ + "img/TwigSmallEon.c8ac3375.png";